import { render } from "./DetailsLinkField.vue?vue&type=template&id=5c23a7b1&scoped=true&ts=true"
import script from "./DetailsLinkField.vue?vue&type=script&lang=ts"
export * from "./DetailsLinkField.vue?vue&type=script&lang=ts"

import "./DetailsLinkField.vue?vue&type=style&index=0&id=5c23a7b1&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c23a7b1"]])

export default __exports__